module.exports = __webpack_public_path__ + "static/media/hsbc.e1e67c8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hsbc.jpg
// module id = 488
// module chunks = 0 1 2